import React, { Component } from 'react';
import { Row, Modal, Form, Select } from 'antd';

const FormItem = Form.Item;
const { Option } = Select;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.loadOrg();
    this.loadAccount();
  }

  submit = () => {
    const data = this.props.form.getFieldsValue();
    this.props.form.validateFields(err => {
      if (!err) {
        this.props.handSubmit(data);
      }
    });
  };

  render() {
    const { cancel } = this.props;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    return (
      <Modal
        title="作废合同"
        width={400}
        visible
        onCancel={cancel}
        onOk={this.submit}
        maskClosable={false}
      >
        <Form className="modal" layout="inline">
          <Row>
            <FormItem {...formItemLayout} label="作废原因">
              {getFieldDecorator('remark', {
                rules: [{ required: true, message: '作废原因不能为空！' }],
              })(
                <Select>
                  <Option value="合同填写有误">合同填写有误</Option>
                  <Option value="客户更换版本原合同作废">客户更换版本原合同作废</Option>
                  <Option value="合同过期收回作废">合同过期收回作废</Option>
                  <Option value="退单退款不合作合同退回">退单退款不合作合同退回</Option>
                  <Option value="签约后违约">签约后违约</Option>
                  <Option value="其它原因">其它原因</Option>
                </Select>,
              )}
            </FormItem>
          </Row>
        </Form>
      </Modal>
    );
  }
}
export default Form.create()(Index);



// WEBPACK FOOTER //
// ./src/components/xianxing/contract/ModalInvalid.js